import AxiosInstance from "./api";

export const CostEstimateSheetService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/cost-estimate-sheets/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/cost-estimate-sheets/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/cost-estimate-sheets", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/cost-estimate-sheets/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/cost-estimate-sheets/" + id);
  },
};
